import React, { Component } from 'react';
import { Grid, Icon } from 'semantic-ui-react';
import { decamelize, printThisObjectClickable } from './util';
import { HttpClient } from './apiCalls/httpClient';
import _ from 'lodash'


export default class BolOutput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openDetails: [],
            now: new Date(),
        }
        this.detailResult = _.get(this.props, "qryOutput.responseParams.responses[0].detail", "");
    }
    render() {
        this.detailResult = _.get(this.props, "qryOutput.responseParams.responses[0].detail", "");
        let resultData = this.props.qryOutput.responseParams.responses ? this.props.qryOutput.responseParams.responses[0] : this.props.qryOutput.responseParams;
        console.log('this.detailResultx : ', this.detailResult );
        /* scss!!!
.bolQueryStyleTable { 
  width:97%;
  margin-left:1%;
  margin-top:5px;
  h1 {display:none;}
  @media not print {
    margin-bottom:400px;
  }
  .collapseablefalse > tbody > tr > td > .icon {
    visibility: hidden;
  }
  .collapseabletrue:not(.depth1) {
    margin-left: -32px;
  }
  .iconHolder {
  }
  h1 { font-size: 1rem;
  margin-bottom: 1px;}
  .iconHolder {  width: 20px;vertical-align: top;}
  .iconHolder, .iconHolder + td {
    border: 0px;
  }
  .iconHolder .icon {
    cursor:pointer;
    font-size: 1.3rem;
    &:hover { 
      filter: drop-shadow(0 0 0.15rem gold);
      }
  }
  .collapsedTitle {
    font-size: 1rem;
    cursor:pointer;
    font-weight: bold;
  }
  table {
    width:100%;
    td {border:1px sold #e5e5e5;
      padding: 1px;
    
    padding-left:2px;}
    thead {
      tr {
        background-color: #33a2a5;
        font-size: 1rem;
        color: white;
        font-weight: bold;
        td {border:1px solid #33a2a5;padding-right:5px;}
      }
    }
    tbody {
      .dataRow td {cursor:text;padding:2px;}
      tr.dataRow:nth-child(even) {background: #f7f7f7}
      tr.dataRow:nth-child(odd) {background: #FFF}
    }
  }

}
          */
        
        //modify the scss and then compile the css! don't modify the below!
        let regularMessage = _.get(resultData,'message',null);
        let bolyStyleBox = `
        .bolQueryStyleTable {
          width: 97%;
          margin-left: 1%;
          margin-top: 5px;
        }
        .bolQueryStyleTable h1 {
          display: none;
        }
        @media not print {
          .bolQueryStyleTable {
            margin-bottom: 400px;
          }
        }
        .bolQueryStyleTable .collapseablefalse > tbody > tr > td > .icon {
          visibility: hidden;
        }
        .bolQueryStyleTable .collapseabletrue:not(.depth1) {
          margin-left: -32px;
        }
        .bolQueryStyleTable h1 {
          font-size: 1rem;
          margin-bottom: 1px;
        }
        .bolQueryStyleTable .iconHolder {
          width: 20px;
          vertical-align: top;
        }
        .bolQueryStyleTable .iconHolder, .bolQueryStyleTable .iconHolder + td {
          border: 0px;
        }
        .bolQueryStyleTable .iconHolder .icon {
          cursor: pointer;
          font-size: 1.3rem;
        }
        .bolQueryStyleTable .iconHolder .icon:hover {
          filter: drop-shadow(0 0 0.15rem gold);
        }
        .bolQueryStyleTable .collapsedTitle {
          font-size: 1rem;
          cursor: pointer;
          font-weight: bold;
        }
        .bolQueryStyleTable table {
          width: 100%;
        }
        .bolQueryStyleTable table td {
          border: 1px sold #e5e5e5;
          padding: 1px;
          padding-left: 2px;
        }
        .bolQueryStyleTable table thead tr {
          background-color: #33a2a5;
          font-size: 1rem;
          color: white;
          font-weight: bold;
        }
        .bolQueryStyleTable table thead tr td {
          border: 1px solid #33a2a5;
          padding-right: 5px;
        }
        .bolQueryStyleTable table tbody .dataRow td {
          cursor: text;
          padding: 2px;
        }
        .bolQueryStyleTable table tbody tr.dataRow:nth-child(even) {
          background: #f7f7f7;
        }
        .bolQueryStyleTable table tbody tr.dataRow:nth-child(odd) {
          background: #FFF;
        }
        

/*start old ui css, delete*/

#qryFuncRightPanel {
  height: calc(100vh - 100px);
}
#qryFuncRightPanel .qryFuncPlaceholderIcon {
  text-align: center;
}
#qryFuncRightPanel .qryFuncPlaceholderIcon img {
  width: 80px;
  height: 100px;
}
#qryFuncRightPanel .outputPlaceholder {
  margin-top: 18%;
}
#qryFuncRightPanel .defaultText {
  opacity: 0.62;
  color: #000000;
  font-family: "Open Sans";
  font-size: 20px;
  letter-spacing: 1px;
  line-height: 24px;
  text-align: center;
}
#qryFuncRightPanel .keyName {
  color: #606060;
  font-family: "Open Sans";
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 17px;
  width: 220px;
  overflow: hidden;
}
#qryFuncRightPanel .keyName + .one.wide.column {
  max-width: 15px;
}
#qryFuncRightPanel .keyValue {
  color: #000000;
  font-family: "Open Sans";
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1.14px;
  line-height: 19px;
}
#qryFuncRightPanel .brokerQryOutput .qryLabel {
  color: #000000;
  font-family: "Open Sans";
  font-size: 20px;
  letter-spacing: 1px;
  line-height: 24px;
}
#qryFuncRightPanel .brokerQryOutput .content {
  background: transparent;
}
#qryFuncRightPanel .brokerQryOutput .btn {
  height: 30px;
  border-radius: 3px;
  font-family: "Open Sans";
  font-size: 16px;
  letter-spacing: 0.53px;
  line-height: 19px;
  text-align: center;
  width: fit-content;
  padding: 5px;
  margin-right: 10px;
  display: inline-block;
  cursor: pointer;
}
#qryFuncRightPanel .brokerQryOutput .exportResultBtn {
  background-color: #008B8F;
  color: #FFFFFF;
}
#qryFuncRightPanel .brokerQryOutput .runAgainBtn {
  box-sizing: border-box;
  border: 1px solid #008B8F;
  background-color: #FFFFFF;
  color: #008B8F;
}
#qryFuncRightPanel .brokerQryOutput .runAgainBtn:hover {
  background-color: #008B8F;
  color: #FFFFFF;
}
#qryFuncRightPanel .brokerQryOutput .runAgainBtn.disabledForm {
  pointer-events: none !important;
  background-color: #CCC;
}
#qryFuncRightPanel .brokerQryOutput .selectQueryBtn {
  box-sizing: border-box;
  border: 1px solid #008B8F;
  background-color: #FFFFFF;
  color: #008B8F;
}
#qryFuncRightPanel .brokerQryOutput .resultOutput {
  position: absolute;
  overflow: auto;
  padding: 15px;
  width: 98%;
}
#qryFuncRightPanel .brokerQryOutput .resultOutput .hideCase {
  display: none;
}
#qryFuncRightPanel .brokerQryOutput .resultOutput .showCase {
  display: block;
}
#qryFuncRightPanel .brokerQryOutput .resultOutput .primaryOutput {
  border-radius: 3px;
  font-family: "Open Sans";
  border-radius: 2px;
  margin-bottom: 20px;
}
#qryFuncRightPanel .brokerQryOutput .resultOutput .secondaryOutput {
  border-radius: 3px;
  background-color: #F9F9F9;
  font-family: "Open Sans";
  margin-bottom: 20px;
}
#qryFuncRightPanel .brokerQryOutput .resultOutput .pscNotApplicable {
  background-color: #F5EBAD;
}
#qryFuncRightPanel .brokerQryOutput .resultOutput .pscNotApplicable .keyName, #qryFuncRightPanel .brokerQryOutput .resultOutput .pscNotApplicable .keyValue {
  color: #FF0000 !important;
}
#qryFuncRightPanel .brokerQryOutput .resultOutput .outputList-row {
  border-bottom: 1px solid #a39696;
  padding-top: 7px;
  padding-bottom: 7px;
}
#qryFuncRightPanel .brokerQryOutput .ui.grid > section.row.widthRow > [class*="four wide"].column {
  width: auto !important;
}
#qryFuncRightPanel .brokerQryOutput .selectcasebtn-row {
  padding-top: 0px;
  padding-bottom: 12%;
}
#qryFuncRightPanel .brokerQryOutput .adcvd-casenumber-row {
  padding-top: 7px;
  padding-bottom: 7px;
}
#qryFuncRightPanel .brokerQryOutput .caseTypeHeading {
  height: 19px;
  width: 330px;
  color: #286084;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 19px;
}
#qryFuncRightPanel .brokerQryOutput .cr-heading, #qryFuncRightPanel .brokerQryOutput .bol-heading {
  color: #286084;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 19px;
}
#qryFuncRightPanel .brokerQryOutput .blueBorder {
  border-color: #226AD7;
}
#qryFuncRightPanel .brokerQryOutput .indented_1 {
  border-left: 2px solid #226AD7;
}
#qryFuncRightPanel .brokerQryOutput .blueBorder.top {
  border-top: 1px solid #226AD7;
}
#qryFuncRightPanel .brokerQryOutput .blueBorder.bottom {
  border-bottom: 1px solid #226AD7;
}

/*end old ui css, delete*/

          `;



          
          const getEntityList = (searchValue, entityType = 'PORT', condition = '', type = '',countryOfDestination="US") => {
            window.GLOBALX_seenPorts = window.GLOBALX_seenPorts || [];
            if(window.GLOBALX_seenPorts[searchValue+countryOfDestination])return;
            window.GLOBALX_seenPorts[searchValue+countryOfDestination]=true;
            const data = {
              eventMessage: {
                entityType,
                searchValue,
                condition,
                type,
                countryOfDestination: countryOfDestination
              },
              eventType: 'GET_ENTITY_LIST',
              eventTime: Date.now()
            }
            HttpClient.custom({
              data
            }).then((responsex)=>{
              window.console.log('responsex: ', responsex);
              try {
                let myport = responsex.data.eventMessage.ports.list.find(a=>a.portCode==searchValue);
                if(myport){
                  window.GLOBALX_seenPorts[searchValue+countryOfDestination] = myport;
                  this.setState({})
                  return;
                } 
                myport = responsex.data.eventMessage.ports.list.find(a=>a.portScheduleKCode==searchValue);
                if(myport){
                  window.GLOBALX_seenPorts[searchValue+countryOfDestination] = myport;
                  this.setState({})
                  return;
                }
              } catch(e){}
            }) 
          }



          let expandCollapseAll = (whichtodo)=>{
            let newstates = {};
            for(let oneid of window.GLOBAL_all_bol_tables[this.state.now]){
              newstates[oneid] = whichtodo == "expand";
            }
            this.setState(newstates);
          }
          let printTableArray = (tablesMainData, depthInRecurse, uniqueAppend) => {
              // console.log('tablesMainData: ', tablesMainData);
              return (tablesMainData || []).map((oneTableX, xxtopleveliii) => {
                  // console.log('oneTableX: ', oneTableX);
                  let uniqueTableId = oneTableX.tableName + "xyz" + xxtopleveliii + "x" + depthInRecurse + ")))))))" + uniqueAppend;
                  if(!window.GLOBAL_all_bol_tables)window.GLOBAL_all_bol_tables={};
                  if(!window.GLOBAL_all_bol_tables[this.state.now])window.GLOBAL_all_bol_tables[this.state.now]=[]
                  if(window.GLOBAL_all_bol_tables[this.state.now].indexOf(uniqueTableId) < 0){
                    window.GLOBAL_all_bol_tables[this.state.now].push(uniqueTableId)
                  }
                 
                  let tableIsCollapsed = oneTableX.tableCollapsable && !this.state[uniqueTableId];
                  let getColIndexBysubString = (fragment) => {
                      let iii = 0;
                      for (let colname of oneTableX.tableColumnNames || []) {
                          if ((colname + "").toLowerCase().includes(fragment.toLowerCase())) return iii;
                          iii++;
                      }
                      return -1;
                  }
                  let hiddenTableSummary = null;
                  if (getColIndexBysubString('description') >= 0) {
                      try {
                          hiddenTableSummary = oneTableX.tableData[oneTableX.tableData.length - 1][getColIndexBysubString('description')];
                      } catch (e) { }
                  }

                  let addPaddingToDisposition = (dispositionstring) =>{
                    if(!dispositionstring || dispositionstring.split(" ").length<2)return dispositionstring;
                    let disp =dispositionstring.split(" ");
                    let start = disp.shift();
                    return <React.Fragment><span style={{display:'inline-block',textAlign:'center',width:'30px'}}>{start}</span>
                    <span style={{display:'inline-block',textAlign:'center',width:'30px'}}>-</span>{disp.join(" ")}</React.Fragment>
                  }
                  let dateAndTimeMassage = (datestring) =>{
                    if(!(datestring||"").match(/^\d{1,2}.\d{1,2}.\d{1,2} \d{4}$/))return datestring;
                    return datestring.slice(0,11)+":"+datestring.slice(11,13)

                  }

                  let colNamesIndexed = {};
                  return (
                      <table key={`${uniqueTableId}${xxtopleveliii}`} className={`depth${depthInRecurse} collapseable${oneTableX.tableCollapsable ? 'true' : 'false'}`}><tbody><tr>
                         <td className={"iconHolder"}>
                          <Icon className="expandCollapseIcon" name={this.state[uniqueTableId] ? 'minus circle' : 'plus circle'} onClick={() => {
                              this.setState({ [uniqueTableId]: !this.state[uniqueTableId] })
                          }} />
                          </td>
                          <td>
                              {tableIsCollapsed && oneTableX.tableCollapsable && <React.Fragment><span className="collapsedTitle" onClick={() => {
                                  this.setState({ [uniqueTableId]: !this.state[uniqueTableId] })
                              }}>
                                {!!_.get(oneTableX,"tableData.length") ? <span>({oneTableX.tableData.length}) &nbsp;</span>:
                                !!_.get(oneTableX,"childTables.length") ? <span>({oneTableX.childTables.length}) &nbsp;</span>:
                                null
                                
                                }
                                  {oneTableX.tableName}
                              </span>
                                  {hiddenTableSummary && <React.Fragment>
                                      &nbsp;- <span className="summaryForHiddenTable">({hiddenTableSummary})</span>
                                  </React.Fragment>}
  
                              </React.Fragment>}
                              <div style={tableIsCollapsed ? { display: 'none' } : {}} className={`childDepth${depthInRecurse}`} key={uniqueTableId}>
                                  {oneTableX.tableColumnNames&& <h1>{oneTableX.tableName}</h1>}
                                  <table>
                                      <thead>
                                          <tr>
                                              {(oneTableX.tableColumnNames || []).map((colName,indexxx) => {
                                                  colNamesIndexed[indexxx]=(colName||"").trim().toLowerCase();;
                                                  return <td key={`${colName}bblp${uniqueTableId}`}>
                                                      {colName}
                                                  </td>
                                              })}
                                          </tr>
                                      </thead>
                                      <tbody>
                                          {(oneTableX.tableData || []).map((oneRowOfData, iiixxi) => {
                                              return <tr key={`${iiixxi}nnbblp${uniqueTableId}`} className="dataRow">
                                                  {(oneRowOfData || []).map((currentRowCellData, lllllllppp) => {
                                                      let isPort =(colNamesIndexed[lllllllppp]||"").toUpperCase().split(" ").find(a=>a=="PORT");
                                                      let portType  ="";
                                                      let searchCondition = "";
                                                      if((colNamesIndexed[lllllllppp]||"").toUpperCase().split(" ").find(a=>a=="UNLADING")){
                                                        portType="POUL";
                                                        searchCondition="US";
                                                      }
                                                      let countryOfDestination = "US";
                                                      if(isPort){

                                                        getEntityList(currentRowCellData, 'PORT', searchCondition, portType,countryOfDestination)
                                                      }
                                                      let portObject = window.GLOBALX_seenPorts && window.GLOBALX_seenPorts[currentRowCellData+countryOfDestination];

                                                      let portText ="";
                                                      if(portObject){
                                                          portText = (portObject.portCity || portObject.portName)?
                                                        `${portObject.portCity || portObject.portName} ${((portObject.portProvince||"").match(/^\d+$/)?"":portObject.portProvince) || portObject.portCountry}`
                                                        :'';
                                                      }
                                                      return <td key={`${currentRowCellData}bblp${oneTableX.tableName + "finaltablecell" + iiixxi + "xyz" + xxtopleveliii + "x" + depthInRecurse}m,${lllllllppp},m${uniqueTableId}`}>
                                                         {colNamesIndexed[lllllllppp]=="qty"?parseInt(currentRowCellData||"0")
                                                          :(isPort && portText)?<React.Fragment>{currentRowCellData} <Icon style={{marginLeft:'20px', opacity: '0.3'}} name="info circle" title={portText}/></React.Fragment>
                                                          :(colNamesIndexed[lllllllppp]||"")=="date & time"?dateAndTimeMassage(currentRowCellData)
                                                          :(colNamesIndexed[lllllllppp]||"")=="disposition code - description"?addPaddingToDisposition(currentRowCellData)
                                                          :currentRowCellData}
                                                      </td>
                                                  })}
                                              </tr>
  
                                          })}
                                          <tr><td colSpan={Math.max((oneTableX.tableColumnNames || []).length, 2)}>
                                              {(() => { return printTableArray(oneTableX.childTables || [], depthInRecurse + 1, uniqueTableId) })()}
                                          </td></tr>
                                      </tbody>
                                  </table>
                              </div>
                          </td></tr></tbody></table>
                  )
              })
          };

         let tablesMainData = _.get(resultData, 'tables', null)
        let errorMessage = _.get(resultData,'errorMessage',null);
         let cases = _.get(resultData, 'cases', null)
         console.log('cgfases: ', cases);
         console.log('cgfases: ', resultData);

        if(cases){//This is the old ui, delete it soon!
          let keyToSortOrder =(key)=> {
              if(key=='inBondNumber')return 11;
              if(key=='masterBillNumber')return 10;
              if(key=='houseBillNumber')return 9;
              if(key=='subHouseBillNumber')return 8;
              if(key=='manifestQuantityUnitQty')return 7.5;
           
              if(key=='manifestQuantity')return 7;
              if(key=='manifestQuantityUnit')return 6;
              if(key=='issuerCodeMBOL')return 5;
              if(key=='issuerCodeHBOL')return 4;
              if(key=='bolType')return 3;
              if(key=='isfIndicator')return 2;
              if(key=='motCode')return 1;
              return 0;
  
          }
          let shipmentBolKeyToSortOrder = (key)=>{
              if(key=='bolMaster')return 9;
              if(key=='bolHouse')return 8;
              if(key=='manifestQty')return 7;
              if(key=='qtyUnit')return 6;
              if(key=='bolType')return 5;
              if(key=='inBondNumber')return 4;
              if(key=='isfStatus')return 3;
              if(key=='mot')return 2;
              return 0;
          }
          let casesSorted = (key)=>{
              if(key=='M')return 100;
              if(key=='H')return 10;
              return 0;
          }
          console.log('cgfases: ', cases);
          return <React.Fragment>
                        {cases.sort((b,a)=>{
                            return(casesSorted(_.get(a,"cbpShipmentBolIsfStatus.bolType","")) - casesSorted(_.get(b,"cbpShipmentBolIsfStatus.bolType","")))})
                            .map((item,xxtopleveliii) => {
                            return (
                                <React.Fragment key={xxtopleveliii+" "+"yyywdorrydatawontchange"}>
                                <Grid.Row key={xxtopleveliii+"yyyworrydatawontchange"} className={`outputList-row`}>
                                    <Grid.Column className="keyName" width={16}><b style={{fontSize: '24px',lineHeight:'30px'}}>
                                        {
                                        item.cbpShipmentBolIsfStatus.bolType=='H'?'House BoL':
                                        item.cbpShipmentBolIsfStatus.bolType=='M'?'Master BoL':
                                        errorMessage?errorMessage:
                                        item.cbpShipmentBolIsfStatus.bolType?`BOL Query Result: '${item.cbpShipmentBolIsfStatus.bolType}'`:
                                        `BOL Query Result:`
                                        
                                    }
                                    </b> 
                                    
                                    {!errorMessage && !!_.get(item,'detail.records',[]).length && 
                                        <div style={{float:'right'}}>
                                            <span className={`btn runAgainBtn`} style={{ "width": "112px" }} onClick={()=>{
                                                let openDetails = this.state.openDetails;
                                                openDetails[xxtopleveliii] = !openDetails[xxtopleveliii];
                                                this.setState({openDetails:openDetails})
                                            }}>Show {this.state.openDetails[xxtopleveliii]?'Less':'More'}  </span>{/*show more show less */}
                                        </div>
                                    }
                        
                        </Grid.Column>
                                </Grid.Row>
                                    {Object.keys(item.cbpShipmentBolIsfStatus).sort((a,b)=>shipmentBolKeyToSortOrder(b)-shipmentBolKeyToSortOrder(a)).map((cbpshipkey,iiixxx)=>{
                                        let keystoskip = ["manifestQty","qtyUnit",'bolType']
                                        if(keystoskip.includes(cbpshipkey))return <React.Fragment key={iiixxx+"dontworrydatawontchange"}></React.Fragment>
                                        return (
                                            <Grid.Row key={iiixxx+"dontworrydatawontchange"} className={`outputList-row`}>
                                                <Grid.Column className="keyName" width={5}>{decamelize(cbpshipkey)}</Grid.Column>
                                                <Grid.Column width={1}></Grid.Column>
                                                <Grid.Column className="keyValue" width={10}>{item.cbpShipmentBolIsfStatus[cbpshipkey]}</Grid.Column>
                                            </Grid.Row>
                                            )
                                    })}
                                    {/* {this.state.openDetails[xxtopleveliii] &&
                                        <Grid.Row className={`blueBorder bottom bol`} style={{ "paddingTop": "5px", "paddingBottom": "5px" }} columns={1}>
                                            <Grid.Column className="keyName" width={16} style={{textAlign:'center'}}>
                                                *&nbsp;&nbsp;&nbsp;&nbsp;*&nbsp;&nbsp;&nbsp;&nbsp;*
                                            </Grid.Column>
                                        </Grid.Row>
                                    } */}
                                    {this.state.openDetails[xxtopleveliii] && item.detail.records && item.detail.records.map((_item) => (<React.Fragment>

                                            <Grid.Row className={`blueBorder bottom bol indented_1`} style={{ "paddingTop": "5px", "paddingBottom": "5px",paddingLeft:'10px' }} columns={1}>
                                                <Grid.Column className="keyValue bol-heading" width={10}>{_item.name}</Grid.Column>
                                            </Grid.Row>

                                            {(_item.values || []).sort((b,a)=>keyToSortOrder(a.key)-keyToSortOrder(b.key)).map((itemvalues,xxiiz) => {
                                                return (
                                                    <Grid.Row key={xxiiz+"dontworrydatawontchangex2"} className={`outputList-row indented_1`}>
                                                        <Grid.Column className="keyName" width={5}>{decamelize(itemvalues.key)}</Grid.Column>
                                                        <Grid.Column width={1}></Grid.Column>
                                                        <Grid.Column className="keyValue" width={10}>{printThisObjectClickable(itemvalues.value,xxiiz+"dontworrydatawontchangex2",this)}</Grid.Column>
                                                    </Grid.Row>
                                                )
                                            })}
                                        </React.Fragment>))
                                    }
                                </React.Fragment>
                            )
                        })
                        }
                    </React.Fragment>
        }
        return (
            <div id='BolOutput' className={`outputData bolOutput`}>
                <style type="text/css">{bolyStyleBox}</style>
                {regularMessage?<React.Fragment><i>{regularMessage}</i><br/><br/></React.Fragment>:<React.Fragment></React.Fragment>}
                <Grid className={`primaryOutput`} columns={3}>
                    {
                        (this.detailResult && this.detailResult.records) ? this.detailResult.records.map((item)=>(
                         <React.Fragment>
                            <Grid.Row className={`outputList-row blueBorder bottom ${this.props.qryInput.qryType}`} columns={1}>
                                <Grid.Column className="keyValue cr-heading" width={10}>{item.name}</Grid.Column>
                            </Grid.Row>
                            {
                                item.values && item.values.map((_item)=>(
                                    <Grid.Row className={`outputList-row`}>
                                        <Grid.Column className="keyName" width={5}>{decamelize(_item.key)}</Grid.Column>
                                        <Grid.Column width={1}></Grid.Column>
                                        <Grid.Column className="keyValue" width={10}>{_item.value}</Grid.Column>
                                    </Grid.Row>
                                ))
                            }
                         </React.Fragment>
                    ))  
                    : tablesMainData ? <div className="bolQueryStyleTable">
                        {(this.state.now || new Date()) +""}  &nbsp;  &nbsp;
                        <input type="Button" className="do-not-print submitButtonText" onClick={()=>{expandCollapseAll("expand")}} style={{padding:'3px'}} value="Expand all"/>  &nbsp;  &nbsp;
                        <input type="Button" className="do-not-print submitButtonText"  onClick={()=>{expandCollapseAll("collapse")}} style={{padding:'3px'}} value="Collapse all"/> 
                        {printTableArray(tablesMainData,1,"")}
                    </div> :
                        ['ISF_HEADER', 'BOL_FORM', 'EN_FORM'].includes(this.props.launchFrom) &&
                        <Grid.Row className={`blueBorder bottom bol`} style={{ "paddingTop": "15px", "paddingBottom": "15px" }} columns={1}>
                            <Grid.Column className="keyValue bol-heading" width={16} style={{ "textAlign": "center" }}>No Records Found.
                                {/* <React.Fragment>
                                    <div><br />Do you want to auto mock response based on following Criteria ?</div>
                                    <div>
                                        <input type="radio" id="mockBolBillMatch" name="" value="NO_BILL_MATCH" />
                                        <label for="html">NO BILL MATCH</label><br />
                                        <br />
                                        OR
                                        <br />
                                        <br />
                                        <input type="radio" id="mockBolNoBillFile" name="fav_language" value="BILL_ON_FILE" />
                                        <label for="css">BILL ON FILE</label><br />
                                        <button>CREATE</button>
                                    </div>
                                </React.Fragment> */}
                            </Grid.Column>
                        </Grid.Row>
                    }
                </Grid>
            </div>
        )
    }
}